/**
 * Class for links on social networks
 */

import { SocialUser } from './social-user';


export interface SocialLink {
  name: 'telegram' | 'facebook' | 'zopim' | 'wechat' | 'fb-msg' | 'viber' | 'line' | 'whatsApp';
  url: string;
  type: string;
}

/**
 * Class for SocialNetwork
 */
export interface SocialNetwork {
  name: SocialNetworksEnum;
  title: string;
  isEnabled: boolean;
  isConnected: boolean;
}

export enum SocialNetworksEnum {
  Google = 'google',
  Facebook = 'facebook',
  Apple = 'apple'
}

export enum AppleSignInEventEnum {
  Success = 'AppleIDSignInOnSuccess',
  Error = 'AppleIDSignInOnFailure'
}

export interface AppleJwtToken {
  aud: string;
  auth_time: number;
  c_hash: string;
  email: string;
  email_verified: 'true' | 'false';
  exp: number;
  iat: number;
  is_private_email: 'true' | 'false';
  iss: string;
  nonce_supported: boolean;
  sub: string;
}

export interface ExtendedSocialUser extends SocialUser {
  isPrivateEmail?: boolean;
}
